import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed0e913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-content-center h-2rem" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-content-center flex-wrap trainIdButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_DiagramTrainTypeManagerStopStationManager = _resolveComponent("DiagramTrainTypeManagerStopStationManager")!
  const _component_DiagramTrainTypeManagerNecessaryTimeManager = _resolveComponent("DiagramTrainTypeManagerNecessaryTimeManager")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DiagramTrainTypeNecessaryTimeTable = _resolveComponent("DiagramTrainTypeNecessaryTimeTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { class: "panel" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Inplace, {
          closable: true,
          class: "flex align-items-stretch",
          onClose: _ctx.changeLineColorAndTypeName
        }, {
          display: _withCtx(() => [
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _ctx.trainType?.lineColor })
            }, "■", 4),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.trainType?.name || "種別名"), 1)
          ]),
          content: _withCtx(() => [
            _createVNode(_component_Dropdown, {
              options: _ctx.LINE_COLORS,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "線の色",
              modelValue: _ctx.lineColor,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lineColor) = $event)),
              class: "w-4rem"
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: _normalizeStyle({ color: slotProps.value })
                    }, "■", 4))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(slotProps.placeholder), 1)
                    ], 64))
              ]),
              option: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: slotProps.option.value })
                }, "■", 4),
                _createTextVNode(" " + _toDisplayString(slotProps.option.label), 1)
              ]),
              _: 1
            }, 8, ["options", "modelValue"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.typeName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeName) = $event)),
              placeholder: "種別",
              class: "w-5rem"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onClose"])
      ])
    ]),
    icons: _withCtx(() => [
      _createVNode(_component_SplitButton, {
        label: "編成+",
        class: "p-button-sm p-button-secondary split-button",
        onClick: _ctx.addTrain,
        model: _ctx.splitButtonItems
      }, null, 8, ["onClick", "model"]),
      _createVNode(_component_DiagramTrainTypeManagerStopStationManager, {
        visible: _ctx.isVisibleStopStationManagerModal,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisibleStopStationManagerModal) = $event)),
        trainType: _ctx.trainType,
        "onUpdate:trainType": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainType) = $event))
      }, null, 8, ["visible", "trainType"]),
      _createVNode(_component_DiagramTrainTypeManagerNecessaryTimeManager, {
        visible: _ctx.isVisibleMeasureNecessaryTimeDialog,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isVisibleMeasureNecessaryTimeDialog) = $event)),
        trainType: _ctx.trainType,
        "onUpdate:trainType": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainType) = $event))
      }, null, 8, ["visible", "trainType"])
    ]),
    default: _withCtx(() => [
      (_ctx.trainType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainType.trainIdList, (id, idx) => {
              return (_openBlock(), _createBlock(_component_Button, {
                class: "m-1 p-button-sm",
                key: id,
                onClick: ($event: any) => (_ctx.changeTrainId(id)),
                style: _normalizeStyle(_ctx.buttonColorStyle)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(idx + 1), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "style"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DiagramTrainTypeNecessaryTimeTable, {
        modelValue: _ctx.necessaryTimesA,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.necessaryTimesA) = $event)),
        boundFor: "A"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_DiagramTrainTypeNecessaryTimeTable, {
        modelValue: _ctx.necessaryTimesB,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.necessaryTimesB) = $event)),
        boundFor: "B"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}